<template>
  <div class="protocol">
    <section>
      <p class="mb0">《共享经济合作伙伴协议》（以下简称“本协议”）为云账户与您（即本协议项下的个体经营者或个体工商户）签订的合作协议。当您点击勾选本协议或实际使用云账户服务时，即表示您已充分阅读、理解并接受本协议的全部内容，并与云账户达成协议。您承诺接受并遵守本协议的所有约定，届时您不应以未阅读本协议的内容或者未获得云账户平台对您问询的解答等理由，主张本协议无效，或要求撤销本协议。如果您不同意本协议的任意内容，请不要勾选或以其他方式确认本协议。如果您对本协议的任何条款或者将来随时可能修改、补充的条款有异议，应当停止注册或停止使用云账户服务。</p>
      <p>
        <u>
          <i>
            本协议中有部分斜体、加下划线的条款，该等条款可能影响您的权益或涉及您的个人信息，请您重点阅读。
          </i>
        </u>
      </p>
      <p>感谢您选择云账户为您提供共享经济综合服务，云账户将依托综合实力竭诚为您提供规范、专业的服务。</p>
    </section>
    <section>
      <h5><u><i>特别声明：</i></u></h5>
      <p>
        <u>
          <i>
            为免疑义，本协议项下的个体经营者（即您）仅限于从事生产经营活动的个人或本协议项下的个体工商户，与您通过其它方式注册在您名下的其他个体工商户没有任何关系。您通过云账户服务的企业客户（含关联方）与您不存在劳动关系、劳务关系或其他类似劳动人事法律关系，且您不是企业客户（含关联方）的法定代表人、股东、董事、监事等人员，否则，您不能承揽云账户为满足该企业客户的业务需求而发布的任务。
          </i>
        </u>
      </p>
      <p>
        <u>
          <i>
            您同意并确认，经云账户认定后，如您所从事的生产经营活动按照云账户内部政策需注册个体工商户的，您应通过津智云商商事登记管理系统完成个体工商户登记注册事项，否则，云账户有权拒绝就该类生产经营活动与您开展合作且不承担违约责任。
          </i>
        </u>
      </p>
      <p>
        <u>
          <i>
            一经发现您违反上述第一段声明，云账户有权取消您使用云账户服务的资格、要求您立刻注销本协议项下的个体工商户，并有权上报和配合相关国家机关，同时保留追究责任主体法律责任的权利。
          </i>
        </u>
      </p>
    </section>
    <section>
      <h5>鉴于：</h5>
      <p>云账户享有使用云账户平台的合法授权，可为您提供共享经济综合服务，主要包括基于您的资质或劳动技能为您匹配适合的生产经营活动以及核算生产经营收入等。您与云账户依据《中华人民共和国民法典》及相关法律法规的规定，本着平等、自愿、诚信的原则，在平等互利的基础上友好协商并签署本协议。</p>
    </section>
    <section>
      <h5>第一条  定义</h5>
      <p>除非本协议另有约定，下列词语应具有以下特定涵义：</p>
      <p>
        <strong>1、云账户平台：</strong>
        指云账户（含其关联方）开发的APP、网站、客户端或其他网络服务系统，包括但不限于津智云商商事登记管理系统、云账户综合服务平台、云账户APP、及云账户助手微信小程序。
      </p>
      <p>
        <strong>2、云账户：</strong>
        指与您开展经营合作的主体，包括云账户（天津）共享经济信息咨询有限公司、云账户（上海）智能科技有限公司及云账户（甘肃）云顶科技有限公司。
      </p>
      <p>
        <strong>3、企业客户：</strong>
        指与云账户（天津）共享经济信息咨询有限公司、云账户（上海）智能科技有限公司或云账户（甘肃）云顶科技有限公司签署《共享经济综合服务协议》、开展业务合作且由个体经营者或个体工商户通过云账户平台提供服务的企业。
      </p>
      <p>
        <strong>4、关联方：</strong>
        指相互间直接或间接持有其中一方的股权总和达到25%或以上的；或者直接或间接同为第三方所拥有或控制股权达到25%或以上的。如果一方通过中间方对另一方间接持有股份，只要其对中间方持股比例达到25%以上，则其对另一方的持股比例按照中间方对另一方的持股比例计算；两个以上具有夫妻、直系血亲、兄弟姐妹以及其他抚养、赡养关系的自然人共同持股同一企业，在判定关联关系时持股比例合并计算。
      </p>
      <p>
        <strong>5、津智云商商事登记管理系统：</strong>
        指云账户（含关联方）开发的用于为个体工商户提供线上服务的的系统。
      </p>
      <p>
        <strong>6、个体工商户：</strong>
        指云账户（天津）共享经济信息咨询有限公司根据与个体工商户经营者签订的《个体工商户登记管理合作协议》协助个体经营者进行个体工商户登记并经云账户主管市场监督管理局核准，注册成立、通过云账户平台从事合法合规生产经营活动的个体工商户（为免疑义，本协议项下的个体工商户不包括个体经营者通过其他途径登记注册的个体工商户）。
      </p>
      <p>
        <strong>7、个体经营者：</strong>
        指自我雇佣、自我管理、自担成本、自负盈亏并通过云账户平台或企业客户平台等从事合法合规生产经营活动的个人或本协议项下的个体工商户。
      </p>
      <p>
        <strong>8、生产经营收入（税后）：</strong>
        指个体经营者通过云账户平台从事生产经营活动取得的经营所得减去根据税收法律法规规定应由个体经营者缴纳的个人所得税之后的收入。
      </p>
      <p>
        <strong>9、服务费：</strong>
        指由云账户向企业客户提供共享经济综合服务，云账户就该服务向企业客户收取的费用。
      </p>
    </section>
    <section>
      <h5>第二条 合作内容</h5>
      <p>1、云账户为满足企业客户的业务需求而通过云账户平台或企业客户平台向适合的个体经营者发布服务内容，您可根据自身资质或劳动技能选择是否接受前述活动。</p>
      <p>2、云账户通过云账户平台或企业客户平台公布企业客户所需的生产经营活动内容、服务规则等，您可据此查询、接受活动内容，并承诺在从事生产经营活动过程中遵守前述服务规则、承担相关义务。云账户根据您任务完成情况核算、支付您的生产经营收入（税后）。</p>
      <p>3、鉴于云账户与企业客户进行了共享经济业务合作，基于企业客户的业务需求，如您与云账户已开展了事实合作且向企业客户提供了服务，则双方对前述事实合作予以追认，前述事实合作同样受本协议的约束。</p>
      <p>4、您应当按照有关税收法律法规、政策规定及税务机关的要求，履行您通过云账户平台向企业客户提供服务取得生产经营收入应承担的个人所得税纳税义务。鉴于云账户具备合法的个人所得税代征资质，云账户将按照有关税收法律法规、政策规定及云账户主管税务机关的要求和您的授权协助您完成上述纳税义务的履行。</p>
    </section>
    <section>
      <h5>第三条 生产经营收入（税后）的结算及支付</h5>
      <p>1、根据云账户与企业客户签署的《共享经济综合服务协议》的约定，云账户基于企业客户业务需求向企业客户提供共享经济综合服务并收取服务费。云账户收到企业客户支付的服务费后，将根据您服务完成情况核算并向您支付生产经营收入（税后），您通过云账户平台每月取得的生产经营收入（税后）金额不超过9.8万元。</p>
      <p>2、您应自行承担您通过云账户平台向企业客户提供服务取得的经营所得应缴纳的各项税费，云账户根据本协议第二条第4款的约定协助您完成个人所得税的缴纳，为此您应配合云账户向云账户主管税务机关申报缴纳个人所得税，并向云账户提供个人所得税申报缴纳所需的相关材料和信息。</p>
    </section>
    <section>
      <h5>第四条 您的权利与义务</h5>
      <p>1、您保证签署本协议时具有完全民事权利能力和民事行为能力或被视为完全民事行为能力人，并满足所有履行本协议所需的法定条件或约定条件，如您不具备前述民事主体资格，则由您或您的法定监护人或其他相关人士依照相关法律规定承担由此产生的全部法律责任。</p>
      <p>2、您保证具有从事云账户发布的生产经营活动所需的资质。如果您所从事的生产经营活动需经相关国家机关许可或以其他方式进行的，您应先行取得相关许可并按照法律规定的方式从事生产经营活动，否则您应自行承担全部法律后果，并赔偿由此给云账户造成的全部损失。</p>
      <p>3、您保证在通过云账户从事生产经营活动时，遵照相关活动规则并自备所需要的设备设施、自行承担必要费用，如因您个人原因造成您本人或任意第三方损害的，由您承担全部法律责任。</p>
      <p>4、您有权在云账户处查询生产经营收入（税后）的核算方式、取得生产经营收入（税后）。您保证与云账户合作的生产经营活动是以您个人名义或您登记注册的个体工商户的名义进行的，与您名下非通过津智云商商事登记管理系统登记注册的个体工商户（为免疑义，特指非本协议项下的个体工商户）没有任何关系；您保证不以云账户的名义从事任何与本协议项下的生产经营活动无关的业务。</p>
      <p>5、如您通过津智云商商事登记管理系统登记注册了个体工商户，您同意并授权由云账户保管该个体工商户的所有证件、公章、印鉴等资料。您不应将注册完成后获取的电子证照用作本协议项下合作事项以外的其他事项，您同时保证不应使用您通过津智云商商事登记管理系统登记注册的个体工商户的名义开展非本协议约定的其他活动，包括但不限于与云账户以外的任何机构进行合作或向其提供服务（与云账户建立合作关系的机构除外）。</p>
      <p>6、您保证在生产经营活动过程中遵守国家法律法规，不得从事违反法律或行政法规等行为（包括但不限于涉嫌传销、赌博、暴力、淫秽、恐怖行为、洗钱、偷税、漏税、逃税）及其他不得使用云账户服务的行为，否则云账户有权中止向您支付生产经营收入或终止本协议。同时，云账户主管税务机关或其他相关国家机关介入调查时，您应当予以协助并如实反映情况，不得阻挠、拒绝调查。</p>
      <p class="mb0">7、您充分理解本协议项下个体经营者的定义及云账户的合作对象范围，并承诺不存在下列所述情形：</p>
      <p class="mb0">7.1承揽的生产经营活动系为了满足与您存在劳动关系、劳务关系或其他类似的劳动人事法律关系的企业客户（含关联方）的业务需求；</p>
      <p class="mb0">7.2承揽的生产经营活动系为了满足由您担任法定代表人、股东、董事、监事等的企业客户（含关联方）的业务需求；</p>
      <p>7.2承揽的生产经营活动系为了满足由您担任法定代表人、股东、董事、监事等的企业客户（含关联方）的业务需求；</p>
      <p class="mb0">7.3您属于其他不适用于云账户服务范围的人员。</p>
      <p>如您属于上述人员，云账户有权暂停或终止向您提供服务，并有权要求您赔偿云账户因此遭受的经济损失。</p>
      <p class="mb0">8、您同意并授权云账户为实现本协议合作目的收集、留存并合法使用您的个人信息，<u><i>云账户收集、使用您个人信息的类型和目的包括：</i></u></p>
      <p class="mb0">
        （1）
        <u>
          <i>
            共享经济综合服务。为了您可以使用云账户共享经济综合服务，向您付款及协助您完成个税缴纳，执行服务验证、升级服务，改善云账户现有服务、帮助云账户设计新服务，云账户将收集并使用您的
            <strong>
              姓名、手机号码、身份证号码或其他有效证件号码、身份证照片、人脸照片及动态面部识别特征、银行账号或其他收款账户信息、个税缴纳信息、活动内容及生产经营收入信息。
            </strong>
          </i>
        </u>
      </p>
      <p class="mb0">
        <u>
          <i>
            （2）客户服务。为方便联系您，同时能够及时响应您的需求，为您提供更好的服务，云账户将收集您的
            <strong>
              电子邮箱、联系地址、联系电话及云账户平台账号。
            </strong>
          </i>
        </u>
      </p>
      <p>
        <u><i>云账户将按照法律规定、采取符合法律及行业标准的安全防护措施保护您的个人信息。</i></u>
      </p>
      <p>
        <u><i>9、您理解并确认，云账户收集、使用您的下列个人信息无需征得您的授权同意：与国家安全、国防安全、犯罪侦查、起诉、审判和执行判决、商业秘密等直接相关的信息、您自行向社会公众公开的信息、云账户从合法公开披露的信息中收集的您的个人信息及其他法律法规或相关国家标准规定无需征得您授权同意的信息。</i></u>
      </p>
      <p>10、您保证向云账户提供的信息均是真实的、有效的、合法的，如信息发生变更应及时通知云账户，否则因此造成的一切不利后果由您承担。您的收款账户信息以您或您通过企业客户提交至云账户的信息为准，且您保证该收款账户为纳税义务人（即您本人）所有。自云账户将应支付的生产经营收入（税后）支付至您的收款账户之日起，视为您收到前述费用。如因您提供信息有误等导致付款失败的，您应独自承担相应责任。您承诺使用前述收款账户的行为符合中华人民共和国法律的规定，如果云账户收到云账户主管税务机关或其他相关国家机关任何调查请求的，您应提供协助并如实反映情况。</p>
      <p>11、如经过云账户认定，您所从事的生产经营活动需要注册个体工商户的，您应当配合提供云账户为协助您登记注册个体工商户所需要收集的您的相关个人信息（包括您的姓名、身份证及其他有效证件的号码及照片、动态面部识别特征、签字样本）。</p>
      <p>12、您须谨慎保管于云账户处注册时所使用的相关信息（包括但不限于账户信息、身份凭证），因您泄露或提供给他人使用该等信息而造成的不利后果，由您自行承担。</p>
      <p class="mb0">13、为向您提供本协议项下约定服务，您授权并同意云账户在下列情形下共享您的个人信息：</p>
      <p class="mb0">
        <u>
          <i>
            （1）与关联方共享：为向您提供共享经济综合服务，您同意并授权云账户将您的个人信息共享给云账户的关联方云账户技术（天津）有限公司。为核实您的身份及准确无误地向您支付生产经营收入（税后），您同意并授权云账户技术（天津）有限公司将您的
            <strong>姓名、身份证号、收款账户信息及联系方式</strong>
            共享给其合作机构进行信息核验，云账户技术（天津）有限公司将采用加密措施保证您的前述个人信息不被泄露。
          </i>
        </u>
      </p>
      <p>
        <u>
          <i>
            （2）与企业客户共享：为给您筛选适当的生产经营活动及了解您的生产经营情况，您授权并同意云账户将您的
            <strong>姓名、身份证号码或其他有效证件号码、生产经营收入及个人所得税缴纳信息</strong>
            共享给企业客户。
          </i>
        </u>
      </p>
      <p><u><i>14、云账户只会共享必要的个人信息，且受本协议合作目的的约束。关联方或企业客户如要改变您个人信息的处理目的，云账户将再次征求您的明示授权同意。对云账户与之共享个人信息的公司、组织和个人，云账户会与其签署严格的保密协定或约定保密条款，要求他们按照云账户的说明、本协议以及其他任何相关的保密约定，采取安全措施来处理个人信息。</i></u></p>
      <p><u><i>15、按照中国相关的法律、法规、标准等相关文件，您有权更正、删除您的个人信息或改变您授权同意的范围，收回授权同意可能影响您使用某些产品或服务，云账户会在您收回授权同意时向您说明。您可以通过本协议第九条中罗列的方式向云账户提出申请，云账户会在收到申请后十五个工作日内（含）回复您的请求。但您收回授权同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</i></u></p>
      <p>16、您应当勤勉履行本协议，维护云账户形象，不得损害云账户的合法权益。</p>
    </section>
    <section>
      <h5>第五条 云账户的权利与义务</h5>
      <p>1、基于企业客户的业务需求及您的资质或劳动技能，云账户有权就您从事的生产经营活动制定相应的活动标准，云账户将敦促您遵守前述活动标准并不得违背相关法律法规，本条款内容不导致云账户与您本人之间构成劳动关系、劳务关系、任何担保或被担保关系，亦不导致云账户对您提供服务所引起的纠纷承担任何连带责任。</p>
      <p>2、在企业客户及时、足额向云账户支付服务费的情况下，您发起的生产经营收入（税后）的提现或支付申请，由云账户根据您任务完成情况核算并向您支付，但您从事的生产经营活动超出云账户发布任务的除外。</p>
      <p>3、云账户在向您支付生产经营收入（税后）时，有权在云账户所在地向云账户主管税务机关代您进行临时税务登记或个体工商户税务登记，并按照有关税收政策规定及云账户主管税务机关的要求，协助您完成个人所得税税款缴纳。</p>
      <p>4、如您通过津智云商商事登记管理系统注册了个体工商户，该个体工商户的所有证件、公章、印鉴等资料，均由云账户代您保管，云账户承诺将妥善保管，并不得出于本协议之外的其他目的而使用。</p>
      <p>5、云账户发现您违反本协议第四条第7款之约定的，有权立即中止或终止履行本协议，有权代您申请注销本协议项下的个体工商户（如适用），且您不得拒绝。此外，云账户有权向主管税务机关报告前述情况，您应自行承担由此产生的法律责任（包括但不限于根据云账户主管税务机关的要求补缴相应的税款、滞纳金、罚金）。</p>
      <p>6、云账户有权留存并合法使用为实现本协议合作目的从您处获取的您的个人信息，云账户（含股东会、董事会、监事会成员及高级管理人员）承诺对您所披露的个人信息进行保密，除经您授权或基于合法并可执行的法律、法规、法院命令、监管机构的要求或为遵守适用法律法规、履行网络安全保护义务或应对网络安全事件的需要外，云账户（含股东会、董事会、监事会成员及高级管理人员）不得将您的个人信息披露给本协议约定之外的任意第三方。云账户承诺按照相关法律法规的要求对您的个人信息履行安全保护义务，保障网络免受未经授权的访问，防止网络数据泄露或被窃取、篡改。</p>
      <p>7、为确保向您提供优质服务，云账户可能需短时间中断服务对云账户平台进行维护和升级，若发生此情形，云账户将尽可能在中断服务前通知您，无论您是否接受到了云账户的事先通知，您理解并同意云账户无需向您承担违约赔偿责任。</p>
      <p>8、云账户应当勤勉履行本协议，不得损害您的合法权益。</p>
    </section>
    <section>
      <h5>第六条 违约责任</h5>
      <p>1、除本协议另有约定外，本协议任意一方不履行或不完全履行本协议约定的义务和承诺即构成违约。违约方应当负责赔偿其违约行为给守约方造成的直接经济损失，包括但不限于合理的律师费、诉讼费、公证费。</p>
      <p>2、如您违反相关法律法规或社会公序良俗给云账户造成损失的，包括但不限于经济损失、商誉或企业形象损失，云账户有权向您主张损害赔偿。</p>
      <p>3、因政府行为（包括但不限于因政府机关不授予或调整云账户相应经营资质或权利）或其他不可抗力因素导致本协议部分条款或全部条款无法履行的，甲乙双方均不向对方承担违约责任。</p>
    </section>
    <section>
      <h5>第七条 保密责任</h5>
      <p>1、本协议任意一方应对本协议所涉及的所有内容以及协议双方在执行本协议过程中相关的法律、商业、合作业务的所有信息进行保密。未经对方允许，均不得向本协议约定之外的任意第三方披露（但前述保密信息已经公开、在签署本协议之前已通过其他合法来源获悉或应司法机关、行政机关要求进行披露的除外）。</p>
      <p>2、保密期限应为：自本协议生效之日起至本协议终止后十年。</p>
    </section>
    <section>
      <h5>第八条 适用法律和争议解决</h5>
      <p>1、如因履行本协议发生争议，应根据实际与您开展合作，并因具体行为对您的权益产生实际影响的相对方，确定该争议下与您履约的主体。</p>
      <p>2、本协议的订立、生效、履行、解释与争议解决均应适用中华人民共和国法律。凡因本协议引起的或与本协议有关的任何争议，协议双方应友好协商解决。如不能协商解决，双方一致同意提交至实际与您开展合作的云账户主体所在地有管辖权的人民法院诉讼解决。</p>
    </section>
    <section>
      <h5>第九条 通知</h5>
      <p class="mb0">1、有效联系方式</p>
      <p class="mb0">云账户为了向您提供本协议项下的服务，有权通过您提供的联系方式（包括您的联系地址、电子邮箱、联系电话等）向您发送各种通知，如您的联系方式发生变更，您有义务及时更新有关信息，并保持可被联系的状态。</p>
      <p>云账户将通过您的联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。</p>
      <p class="mb0">2、通知的送达</p>
      <p class="mb0">云账户通过上述联系方式向您发出通知，其中：以电子方式发出的书面通知，包括但不限于在云账户平台中发布公告或通知消息、向您的联系电话发送手机短信、向您的电子邮箱发送电子邮件及通过客服向您发送通知，通知在发送成功后即视为送达。</p>
      <p>您可以通过您预留的电子邮箱、云账户平台的在线客服、服务热线等方式向云账户发出通知，您通过前述联系方式发出的通知视为您本人的意思表示，在发送成功后即视为送达；您以纸质载体发出的书面通知，按照云账户联系地址交邮妥投后的第五个自然日即视为送达。</p>
    </section>
    <section>
      <h5>第十条 协议的签署、变更与终止</h5>
      <p>1、为向您提供更好的服务，并更高效的与您开展合作，在不影响您的实体权利和合法权益、不降低服务品质的情况下，云账户可以选择合适的主体与您开展合作并提供服务。为减少在此过程中给您造成的打扰，本协议在您与任一实际开展合作并提供服务的云账户主体之间均适用并有效，双方无需另行签署书面协议。如您需要与实际合作的主体分别签署单独的书面协议，可以通过云账户平台在线客服或服务热线联系云账户并提出需求，云账户将予配合。与您实际开展合作的云账户主体是签署并履行本协议的法律主体，您可以随时查看云账户客户端的相关信息，或根据实际合作信息确定与您履约的云账户主体。</p>
      <p>2、与您开展合作的云账户主体可能根据业务调整而发生变更，主体的变更不会影响您在本协议项下的权益。您以任何方式明确同意、与变更后的云账户主体就合作的经营活动进行结算，或以其他实际行动表明同意与变更后的云账户主体合作的，视为您同意与变更后的云账户主体签署并履行本协议。</p>
      <p>3、为适应业务的迭代与优化，云账户可在遵循公平、诚实信用等基本原则的情况下更新本协议条款，并在云账户平台、企业客户平台或以其他方式予以公布（如各平台协议内容存在差异的，应以云账户平台内公布的协议版本为准）。如您同意所修改的内容，请通过点击勾选、继续接受云账户付款等方式，或以其他继续使用云账户服务的方式予以确认；如您不同意所修改的内容，请停止使用云账户服务。</p>
      <p class="mb0">4、如发生以下任一情形，您有权以本协议第九条所列的联系方式通知云账户终止本协议：</p>
      <p class="mb0">4.1云账户破产或被取消营业资格的；</p>
      <p class="mb0">4.2本协议更新后，您不同意所修改内容并停止使用云账户服务的；</p>
      <p>4.3您不愿继续使用云账户服务的。</p>
      <p class="mb0">5、您应遵守本协议约定、相关法律法规的规定及社会公序良俗，云账户有权自主判断您的行为是否违约或违规。发生下列情形时，云账户有权在不事先通知的情况下，限制或停止您使用云账户服务的资格，情形严重的，云账户有权以本协议第九条所列的方式通知您终止本协议并有权根据云账户与您签订的《个体工商户登记管理合作协议》要求您注销个体工商户登记（如适用），且您认可通过这种途径致使个体工商户注销的法律后果：</p>
      <p class="mb0">5.1云账户有合理理由或有证据认定您违反本协议约定、相关法律法规规定或社会公序良俗的（包括但不限于您涉嫌开展传销、赌博、暴力、淫秽、恐怖行为、洗钱、偷税、漏税、逃税等行为）；</p>
      <p class="mb0">5.2云账户有合理理由或有证据认定您存在危害国家统一、颠覆国家政权、损害国家荣誉或利益、破坏民族团结的行为或发表前述相关言论的；</p>
      <p class="mb0">5.3您违反云账户的活动规则、超出电子营业执照范围开展经营活动、利用电子营业执照与除云账户之外的其他合作方开展经营活动或通过实体商户从事经营活动，且在云账户警告后3个工作日内（含）仍未改正的；</p>
      <p class="mb0">5.4云账户按照法律规定或有权机关的要求终止向您提供服务的；</p>
      <p>5.5其他原因导致本协议无法继续履行的。</p>
    </section>
    <section>
      <h5>第十一条 其他</h5>
      <p>其他未尽事宜，双方协商解决并可另行签订本协议的补充协议（包括但不限于云账户平台通知、弹窗内容等）。补充协议应视为本协议不可分割的一部分，与本协议具有同等法律效力。</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Protocol'
}
</script>
<style lang="scss" scoped>
.protocol {
  section {
    margin-bottom: 30px;
    h5 {
      font-weight: 600;
      font-size: 30px;
      margin-bottom: 20px;
    }
    ul.disc {
      padding-left: 40px;
      li {
        list-style: disc;
      }
    }
    p,
    li {
      margin-bottom: 15px;
      line-height: 40px;
      color: #4f4f4f;
      font-size: 26px;
    }
    p {
      text-indent: 2em;
    }
    .mb0 {
      margin-bottom: 0;
    }
  }
}
</style>
